/* =================================================================
   MERYIA — Batch 4 (loaded on every page by sections/meryia-style-layer.liquid)
   1. Product-card quick add: "Choose options" → "Add to cart" (the size is picked in the popup)
   2. Hero carousel on phones: the dots / progress bar sit right above the buttons
   ================================================================= */
(function () {
  if (window.__meryiaB4) return;
  window.__meryiaB4 = true;

  var isAr = function () { return document.documentElement.classList.contains('meryia-ar'); };

  /* 1 — quick add label */
  function relabel(root) {
    (root || document).querySelectorAll('modal-opener .quick-add__submit').forEach(function (b) {
      if (b.__mb4) return;
      b.__mb4 = true;
      var label = isAr() ? 'أضيفي للسلة' : 'Add to cart';
      for (var n = b.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && n.nodeValue.trim()) { n.nodeValue = label; return; }
      }
    });
  }

  /* 2 — hero dots above the buttons (phones only) */
  function heroDots() {
    var car = document.querySelector('meryia-carousel.mh-carousel');
    if (!car) return;
    var dots = car.querySelector('.mh-carousel__dots');
    if (!dots) return;
    var mq = window.matchMedia('(max-width: 749px)');

    /* NOTE: only touch the DOM when something actually changes — classList.add() fires a mutation even
       when the class is already there, which would re-trigger the observer below in an endless loop. */
    function place() {
      if (!mq.matches) {
        if (dots.parentNode !== car) car.appendChild(dots);
        if (dots.classList.contains('is-inline')) dots.classList.remove('is-inline');
        return;
      }
      var slide = car.querySelector('.mh-slide.is-active');
      if (!slide) return;
      var btns = slide.querySelector('.mh-slide__btns');
      var bar = slide.querySelector('.mh-slide__bar');
      var target = btns ? btns.parentNode : bar;
      var before = btns || (bar && bar.firstChild);
      if (!target) return;
      if (before !== dots && (dots.parentNode !== target || dots.nextSibling !== before)) target.insertBefore(dots, before);
      if (!dots.classList.contains('is-inline')) dots.classList.add('is-inline');
    }

    place();
    /* react only to a slide becoming active (not to the dots' own class changes) */
    new MutationObserver(function (muts) {
      if (muts.some(function (m) { return m.target.classList && m.target.classList.contains('mh-slide'); })) place();
    }).observe(car.querySelector('.mh-carousel__viewport') || car, {
      attributes: true, attributeFilter: ['class'], subtree: true
    });
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  }

  function start() {
    relabel(document);
    heroDots();
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) relabel(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { relabel(document); heroDots(); });
})();
